import React, { useState, useEffect } from 'react';
import { Button, Col, Row, Input } from 'antd/lib';
import * as Icons from '@ant-design/icons';

const { TextArea } = Input;

function Caratula(props) {
  // ESTADOS
  const [caratulaEditable, setCaratulaEditable] = useState(false);
  const [caratula, setCaratula] = useState(props.acuerdo.caratula);

  useEffect(() => {
    if (props.acuerdo.caratula !== caratula) {
      setCaratula(props.acuerdo.caratula);
    }
  }, [props.acuerdo.caratula]);

  const guardar = () => {
    props.guardarCaratula(caratula);
  };

  const imprimir = () => {
    props.imprimirCaratula(caratula);
  };

  return (
    <>
      <Row style={{ marginTop: 20 }}>
        <Col span={10} offset={2}>
          <h3>Caratula:</h3>
        </Col>
        <Col span={9}>
          <Button
            style={{ marginRight: 9 }}
            size="small"
            type="primary"
            onClick={() => setCaratulaEditable(true)}
            icon={<Icons.EditOutlined />}
          >
            Editar
          </Button>
          <Button
            style={{ marginRight: 9 }}
            size="small"
            icon={<Icons.SaveOutlined />}
            onClick={guardar}
          >
            Guardar
          </Button>
          <Button
            size="small"
            type="primary"
            icon={<Icons.PrinterOutlined />}
            onClick={imprimir}
            disabled={!caratula || caratulaEditable}
          >
            Imprimir
          </Button>
        </Col>
      </Row>

      <Row style={{ marginTop: 5 }} type={'flex'}>
        <Col span={22} offset={1}>
          <p>
            <TextArea
              style={{ marginLeft: 25, width: '75%' }}
              autoSize={{ minRows: 3, maxRows: 8 }}
              value={caratula}
              onChange={e => setCaratula(e.target.value)}
              disabled={!caratulaEditable}
            />
          </p>
        </Col>
      </Row>
    </>
  );
}

export default Caratula;
